// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:960px){.menu-wrapper[data-v-3218283c]{background-color:#f8f8f8}}.v-tab[data-v-3218283c]{text-transform:none!important}.v-slide-group__next[data-v-3218283c],[data-v-3218283c] .v-slide-group__prev{display:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
